export function ToTitleCase(str) {
  return (str || '').replace(/_/g, ' ').replace(/(^|\s)[a-z]/g, (f) => f.toUpperCase());
}
